
import React, { useState } from "react";
import MUICard from "./../../../../Component/UI/MUICard/MUICard";
import CompetitorItem from "./CompetitorItem";
import classes from "./Competitors.module.css";
import EmptyView from "../../../../Component/EmptyView/EmptyView";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Tooltip from "@mui/material/Tooltip";

export default function Competitors({
  compBrandIndexScore,
  pastCompBrandIndexScore,
  brandDomains,
  compIndexScoreMetaData,
  isChecked,
  handleClickShow,
  selectedInput,
}) {
  const [visibleCount, setVisibleCount] = useState(4);

  function transformData(data) {
    const brandNames = data && Object.keys(data["Brand Index Score"]);

    return brandNames?.map((brand) => ({
      name: brand,
      BrandIndexScore: parseFloat(data["Brand Index Score"][brand]),
      Favorability: data.Favorability[brand],
      Rank: data.Rank[brand],
    }));
  }

  function calculateBrandIndexDelta(currentData, previousData, metaData) {
    const findBrandInPrevious = (prevData, brandName) =>
      prevData?.find((prevObj) => prevObj?.name === brandName);

    const findMetaDataInBrand = (metaData, brandName) =>
      metaData?.find((obj) => obj?.name === brandName);

    return currentData?.map((currentBrand) => {
      const prevBrand = findBrandInPrevious(previousData, currentBrand.name);
      const brandMetaData = findMetaDataInBrand(metaData, currentBrand.name);

      const prevScore = prevBrand ? prevBrand?.BrandIndexScore : null;
      const prevFav = prevBrand ? prevBrand?.Favorability : null;
      const prevRank = prevBrand ? prevBrand?.Rank : null;

      const scoreDelta =
        prevScore !== null ? currentBrand?.BrandIndexScore - prevScore : null;
      const favDelta =
        prevFav !== null ? currentBrand?.Favorability - prevFav : null;
      const rankDelta =
        prevRank !== null ? currentBrand?.Rank - prevRank : null;

      return {
        ...currentBrand,
        delta: scoreDelta,
        favDelta: favDelta,
        rankDelta: rankDelta,
        metaData: brandMetaData,
      };
    });
  }

  const transformed = transformData(compBrandIndexScore) || [];

  const toggleShowMore = () => {
    const totalCompetitors = transformed.length;
    
    if (visibleCount < totalCompetitors) {
      // Expand to show all
      setVisibleCount(totalCompetitors);
    } else {
      // Collapse to show only 4
      setVisibleCount(4);
    }
  };

  const isExpanded = visibleCount >= transformed.length;

  const compIndexScoreData = transformed.slice(0, visibleCount);
  const pastCompIndexScoreData = transformData(pastCompBrandIndexScore);

  const indexScoreDataWithDelta = calculateBrandIndexDelta(
    compIndexScoreData,
    pastCompIndexScoreData,
    compIndexScoreMetaData
  );

  return (
    <MUICard
      title={
        <div className={classes.titleWithIcon}>
          Competitor Analysis

          <Tooltip
            title={
              isExpanded
                ? "Collapse competitors"
                : "Expand to view more competitors"
            }
            placement="top"
            arrow
          >
            <span className={classes.iconWrapper}>
              {isExpanded ? (
                <KeyboardArrowUpIcon onClick={toggleShowMore} fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon onClick={toggleShowMore} fontSize="small" />
              )}
            </span>
          </Tooltip>
        </div>
      }
      variant="elevated"
      elevation={0}
      className={classes.card}
      titleClassName={classes.title}
      width={"100%"}
    >
      <div className={classes.container}>
        {indexScoreDataWithDelta && indexScoreDataWithDelta.length ? (
          <>
            {indexScoreDataWithDelta.map((data, index) => (
              <CompetitorItem
                key={index}
                brandDomains={brandDomains}
                indexScoreData={data}
                isChecked={isChecked}
                handleClickShow={handleClickShow}
                selectedInput={{
                  ...selectedInput,
                  brand: data?.name,
                  product: data?.name,
                }}
              />
            ))}

          </>
        ) : (
          <EmptyView message="Data Not Available" />
        )}
      </div>
    </MUICard>
  );
}

